var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      {
        staticClass: "bg-white ",
        staticStyle: { height: "calc(100%)", "overflow-y": "auto" },
      },
      [
        _c(
          "el-card",
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "searchForm",
                        attrs: { size: "small", model: _vm.detForm },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "项目编号：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.detForm.proCode)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "项目名称：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.detForm.name)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "工程类别：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.detForm.kindName1)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "工程类型：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.detForm.kindName2)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "施工单位：" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.setWorkUnitText(
                                            _vm.detForm.workUnitId
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "施工指示：" } },
                                  [
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.detForm.workPoint)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "注意事项：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.detForm.workNote)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "常规标准：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.detForm.workStandard)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "", label: "备注信息：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.detForm.remarks)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("ImageColumn", {
                      attrs: { imageArray: _vm.detForm.picJsonList },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "tableTitle" }, [_vm._v("涉及项目：")]),
        _c(
          "div",
          { staticStyle: { "min-height": "calc(40% - 20px)" } },
          [
            _c(
              "vxe-table",
              {
                ref: "cecUnmSetsTable",
                attrs: {
                  border: "full",
                  "auto-resize": "",
                  resizable: "",
                  height: "auto",
                  loading: _vm.loading,
                  size: "small",
                  "show-header-overflow": "",
                  "show-overflow": "",
                  "highlight-hover-row": "",
                  "menu-config": {},
                  "print-config": {},
                  "import-config": {
                    importMethod: _vm.importMethod,
                    types: ["csv", "xls", "xlsx"],
                    remote: true,
                  },
                  "export-config": {
                    remote: true,
                    filename:
                      "套餐表数据" +
                      _vm.moment(new Date()).format("YYYY-MM-DD"),
                    sheetName: "套餐表数据",
                    exportMethod: _vm.exportMethod,
                    types: ["xlsx"],
                    modes: ["current", "selected", "all"],
                  },
                  "sort-config": { remote: true },
                  data: _vm.detForm.others,
                  "checkbox-config": {},
                },
                on: { "sort-change": _vm.sortChangeHandle },
              },
              [
                _c("vxe-column", {
                  attrs: { type: "seq", width: "60", title: "序号" },
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "proCode",
                    align: "center",
                    title: "项目编号",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "kindName1",
                    align: "center",
                    title: "工程类别",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "kindName1",
                    align: "center",
                    title: "工程类型",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }